import React from "react";
import "./signup.css";
import Input from "../component/inp";
import Course from "../component/course";
import Header from "../component/header";
import { registerForm } from "../Redux/action/homeAction";
import { connect } from "react-redux";
import firebase from "firebase";
class Signup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matric: false,
      inter: false,
      graduate: false,
      master: false,
      oLevel: false,
      aLevel: false,
      GraduationInstitute: "",
      GraduationYear: "",
      GraduationMarks: "",
      GraduationTotalMarks: "",
      GraduationPern: "",
      MasterInstitute: "",
      MasterYear: "",
      MasterMarks: "",
      MasterTotalMarks: "",
      MasterPern: "",
      matricYear: "",
      matricInstitute: "",
      interMarks: "",
      interYear: "",
      interInstitute: "",
      interPern: "",
      interTotalMarks: "",
      matricMarks: 0,
      matricTotalMarks: 0,
      matricPern: 0,
      city: "Karachi",
      value: "",
      date: "",
      fullName: "",
      email: "",
      stnNic: "",
      fatherName: "",
      FatGuarCNIC: "",
      resAddress: "",
      contact: "",
      whatsapp: "",
      gender: "Male",
      selectedCourse: "",
      selectedCourseList: [],
      chkSelectedCourse: false,
      chkSelectedCourseList: false,
      chkemail: false,
      chkfullName: false,
      chkstnNic: false,
      chkfatherName: false,
      chkFatGuarCNIC: false,
      chkresAddress: false,
      chkcontact: false,
      chkwhatsapp: false,
      chkcity: false,
      chkgender: false,
      chkdate: false,
      chkmatric: false,
      chkinter: false,
      courseControl: {
        fiaOpen: true,
        accaOpen: true,
        caicapOpen: false,
        icmapOpen: false,
        ciaOpen: false,
        cimaOpen: false,
        icaewOpen: false,
      },
      //   course
      fia: [
        "FA1-Recording Financial Transactions",
        "FA2-Maintaining Financial Records",
        "MA1-Management Information",
        "MA2-Managing costs and Finances",
      ],
      acca: [
        "F1-Business and Technology (BT)",
        "F2-Management Accounting (MA)",
        "F3-Financial Accounting (FA)",
        "F4-Corporate and Business Law (LW)",
        "F5-Performance Management (PM)",
        "F6-Taxation (TX)",
        "F7-Financial Reporting (FR)",
        "F8-Audit and Assurance (AA)",
        "F9-Financial Management (FM)",
        "Strategic Business Leader (SBL)",
        "Strategic Business Reporting (SBR)",
        "Advanced Financial Management (AFM)",
        "Advanced Performance Management (APM)",
        "Advanced Taxation (ATX)",
        "Advanced Audit and Assurance (AAA)",
      ],
      caicap: [
        "AFC1-Functional English",
        "AFC1-Functional English",
        " AFC2-Business Communication",
        " AFC3-Quantitative Methods",
        " AFC4-Introduction To Information Technology",
        " CAF1-Introduction To Accounting",
        " CAF2-Introduction To Economics And Finance",
        " CAF3-Business Law",
        " CAF4-Business Management And Behavioral Studies",
        " CAF5-Financial Accounting And Reporting I",
        "  CAF6-Principles Of Taxation",
        " CAF7-Financial Accounting And Reporting Ii",
        " CAF8-Cost And Management Accounting",
        " CAF9-Audit And Assurance",
        " PCSC-Presentation And Communication Skills Course",
        "  CFAP1-Advanced Accounting And Financial Reporting",
        "  CFAP2-Corporate Laws",
        " CFAP3-Business Management And Strategy",
        " CFAP4-Business Finance Decisions",
        "  CFAP5-Advanced Taxation",
        " CFAP6-Audit, Assurance And Related Services",
        " MSA1-Financial Reporting And Assurance Professional Competence",
        " MSA2-Management Professional Competence",
      ],
      icmap: [
        "  O1-Fundamentals of Financial Accounting",
        " O2-Business Economics",
        "  O3-Business Communication and Report Writing",
        " O4-Fundamentals of Management",
        " O5-Business Mathematics & Statistical Inference",
        " O6-Commercial Laws",
        " M1-Fundamentals of Cost & Management Accounting",
        " M2-Enterprise Management",
        " M3-Management Information Systems",
        " M4-Financial Accounting & Corporate Reporting",
        " M5-Management Accounting",
        " M6-Corporate Governance, Business Laws & Ethics",
        " S1-Advanced Financial Accounting & Corporate Reporting",
        " S2-Audit & Assurance",
        " S3-Business Taxation",
        " S4-Strategic Management Accounting",
        " S5-Strategic Financial Management",
        " S6-Strategic Management",
      ],
      cia: [
        "  Part 1–Essentials of Internal Auditing",
        " Part 2-Practice of Internal Auditing, ",
        "  Part 3-Business Knowledge for Internal Auditing",
      ],
      cima: [
        " E1-Enterprise Operations",
        " P1-Performance Operations",
        " F1-Financial Operations",
        " E2-Enterprise Management",
        " P2-Performance Management",
        " F2-Financial Management",
        " E3-Enterprise Strategy",
        "  P3-Performance Strategy",
        " F3-Financial Strategy",
        " T4-Test of Professional Competence in Management Accounting (Part 1)",
        " T4-Test of Professional Competence in Management Accounting (Part 2)",
      ],
      icaew: [
        "  Certificate Level-Accounting",
        "  Certificate Level-Assurance",
        "  Certificate Level-Business, Technology and Finance",
        "  Certificate Level-Law",
        "  Certificate Level-Management Information",
        "  Certificate Level-Principles of Taxation",
        "  Professional Level-Audit and Assurance",
        "  Professional Level-Business Strategy and Technology",
        "  Professional Level-Financial Accounting and Reporting",
        "  Professional Level-Financial Management",
        "  Professional Level-Tax Compliance",
        "  Professional Level-Business Planning",
        "  Advanced Level-Corporate Reporting",
        "  Advanced Level-Strategic Business Management",
        "  Advanced Level-Case Study",
      ],
      cities: [
        " Abbotabad",
        "Ahmedpur East",
        "Arif Wala",
        "Attock",
        "Badin",
        "Bahawalnagar",
        "Bahawalpur",
        "Bhakkar",
        "Bhalwal",
        "Burewala",
        "Chakwal",
        "Chaman",
        "Charsadda",
        "Chiniot",
        "Chishtian",
        "Dadu",
        "Daharki",
        "Daska",
        "Dera Ghazi Khan",
        "Dera Ismail Khan",
        "Faisalabad",
        "Ferozwala",
        "Ghotki",
        "Gojra",
        "Gujranwala",
        "Gujranwala Cantonment",
        "Gujrat",
        "Hafizabad",
        "Haroonabad",
        "Hasilpur",
        "Hub",
        "Hyderabad",
        "Islamabad",
        "Jacobabad",
        "Jaranwala",
        "Jatoi",
        "Jhang",
        "Jhelum",
        "Kabal",
        "Kamalia",
        "Kamber Ali Khan",
        "Kāmoke",
        "Kandhkot",
        "Karachi",
        "Kasur",
        "Khairpur",
        "Khanewal",
        "Khanpur",
        "Khushab",
        "Khuzdar",
        "Kohat",
        "Kot Abdul Malik",
        "Kot Addu",
        "Kotri",
        "Lahore",
        "Larkana",
        "Layyah",
        "Lodhran",
        "Mandi Bahauddin",
        "Mansehra",
        "Mardan",
        "Mianwali",
        "Mingora",
        "Mirpur",
        "Mirpur Khas",
        "Mirpur Mathelo",
        "Multan",
        "Muridke",
        "Muzaffarabad",
        "Muzaffargarh",
        "Narowal",
        "Nawabshah",
        "Nowshera",
        "Okara",
        "Pakpattan",
        "Peshawar",
        "Quetta",
        "Rahim Yar Khan",
        "Rawalpindi",
        "Sadiqabad",
        "Sahiwal",
        "Sambrial",
        "Samundri",
        "Sargodha",
        "Shahdadkot",
        "Sheikhupura",
        "Shikarpur",
        "Sialkot",
        "Sukkur",
        "Swabi",
        "Tando Adam",
        "Tando Allahyar",
        "Tando Muhammad Khan",
        "Taxila",
        "Turbat",
        "Umerkot",
        "Vehari",
        "Wah Cantonment",
        "Wazirabad",
      ],
      currentData: [],
      corseFromDatabse: {},
      chkcontactlen: false,
      chkwhatsapplen: false,
      aPlusOlevel: "",
      aOlevel: "",
      bOlevel: "",
      cOlevel: "",
      dOlevel: "",
      eOlevel: "",
      uOlevel: "",
      aPlusAlevel: "",
      aAlevel: "",
      bAlevel: "",
      cAlevel: "",
      dAlevel: "",
      eAlevel: "",
      uAlevel: "",
      olevelInstitute: "",
      olevelYear: "",
      aLevelInstitute: "",
      aLevelYear: "",
      chkstnNicLen: false,
      chkFatGuarCNICLen: false,
      matricYearlen: false,
      interYearlen: false,
      GraduationYearlen: false,
      MasterYearlen: false,
      oLevelYearlen: false,
      aLevelYearlen: false,
      chkstdIncome: false,
      chkfthIncome: false,
      stdIncome: "",
      fthIncome: "",
      stdOccupation: "",
      fthOccupation: "",
      stdOrganization: "",
      fthOrganization: "",
      stdDepartment: "",
      fthDepartment: "",
      stdDesignation: "",
      fthDesignation: "",
      stdDependent: "",
      fthDependent: "",
      chkstdOccupation: false,
      chkfthOccupation: false,
      chkstdOrganization: false,
      chkfthOrganization: false,
      chkstdDepartment: false,
      chkfthDepartment: false,
      chkstdDesignation: false,
      chkfthDesignation: false,
      chkstdDependent: false,
      chkfthDependent: false,
    };
  }
  componentDidMount() {
    firebase
      .database()
      .ref("/")
      .child("/courseControl")
      .on("value", (course) => {
        let courseFromDatabase = course.val();
        this.setState({ courseControl: course.val() });
      });
  }
  checkField(val) {
    if (!val) return true;
    else return false;
  }
  checkFieldArr(val) {
    if (val.length == 0) return true;
    else return false;
  }

  onChangeValueHandler = (e, val, stat) => {
    this.setState({ [val]: e.target.value, [stat]: false });
  };

  handleChange(e, val) {
    const item = val;
    if (e.target.checked) {
      this.setState({
        selectedCourseList: [...this.state.selectedCourseList, item],
        chkSelectedCourseList: false,
      });
    } else {
      const index = this.state.selectedCourseList.indexOf(5);
      this.state.selectedCourseList.splice(index, 1);
    }
  }

  submitForm = () => {
    const {
      fullName,
      stnNic,
      fatherName,
      FatGuarCNIC,
      resAddress,
      contact,
      whatsapp,
      email,
      city,
      gender,
      date,
      matricMarks,
      matricTotalMarks,
      matricPern,
      matricYear,
      matricInstitute,
      interMarks,
      interTotalMarks,
      interPern,
      interYear,
      interInstitute,
      selectedCourse,
      selectedCourseList,
      GraduationInstitute,
      GraduationYear,
      GraduationMarks,
      GraduationTotalMarks,
      GraduationPern,
      MasterInstitute,
      MasterYear,
      MasterMarks,
      MasterTotalMarks,
      MasterPern,
      currentData,
      aLevelInstitute,
      aLevelYear,
      aPlusOlevel,
      aOlevel,
      bOlevel,
      cOlevel,
      dOlevel,
      eOlevel,
      uOlevel,
      aPlusAlevel,
      aAlevel,
      bAlevel,
      cAlevel,
      dAlevel,
      eAlevel,
      uAlevel,
      olevelInstitute,
      olevelYear,
      stdIncome,
      fthIncome,
      stdOccupation,
      fthOccupation,
      stdOrganization,
      fthOrganization,
      stdDepartment,
      fthDepartment,
      stdDesignation,
      fthDesignation,
      stdDependent,
      fthDependent,
    } = this.state;
    if (this.checkField(fullName)) {
      this.setState({ chkfullName: true });
      window.scrollTo(0, 100);
    } else if (this.checkField(stnNic)) {
      this.setState({ chkstnNic: true });
      window.scrollTo(0, 100);
    } else if (stnNic.length != 13) {
      this.setState({ chkstnNicLen: true });
      window.scrollTo(0, 100);
    } else if (this.checkField(fatherName)) {
      this.setState({ chkfatherName: true });
      window.scrollTo(0, 300);
    } else if (this.checkField(FatGuarCNIC)) {
      this.setState({ chkFatGuarCNIC: true });
      window.scrollTo(0, 300);
    } else if (FatGuarCNIC.length != 13) {
      this.setState({ chkFatGuarCNICLen: true });
      window.scrollTo(0, 300);
    } else if (this.checkField(email)) {
      this.setState({ chkemail: true });
      window.scrollTo(0, 600);
    } else if (this.checkField(resAddress)) {
      this.setState({ chkresAddress: true });
      window.scrollTo(0, 500);
    } else if (this.checkField(contact)) {
      this.setState({ chkcontact: true });
      window.scrollTo(0, 500);
    } else if (contact.length != 11) {
      this.setState({ chkcontactlen: true });
      window.scrollTo(0, 500);
    } else if (this.checkField(whatsapp)) {
      this.setState({ chkwhatsapp: true });
      window.scrollTo(0, 600);
    } else if (whatsapp.length != 11) {
      this.setState({ chkwhatsapplen: true });
      window.scrollTo(0, 500);
    } else if (this.checkField(city)) {
      this.setState({ chkcity: true });
      window.scrollTo(0, 600);
    } else if (this.checkField(gender)) {
      this.setState({ chkgender: true });
      window.scrollTo(0, 600);
    } else if (this.checkField(date)) {
      this.setState({ chkdate: true });
      window.scrollTo(0, 700);
    } else if (matricYear.length > 4) {
      this.setState({ matricYearlen: true });
      window.scrollTo(0, 1300);
    } else if (interYear.length > 4) {
      this.setState({ interYearlen: true });
      window.scrollTo(0, 1300);
    } else if (GraduationYear.length > 4) {
      this.setState({ GraduationYearlen: true });
      window.scrollTo(0, 1300);
    } else if (MasterYear.length > 4) {
      this.setState({ MasterYearlen: true });
      window.scrollTo(0, 1300);
    } else if (olevelYear.length > 4) {
      this.setState({ oLevelYearlen: true });
      window.scrollTo(0, 1300);
    } else if (aLevelYear.length > 4) {
      this.setState({ aLevelYearlen: true });
      window.scrollTo(0, 1300);
    }
    // else if (this.checkField(matricMarks)) {
    //   this.setState({ chkmatric: true, matric: true });
    //   window.scrollTo(0, 1200);
    // }
    //  else if (this.checkField(matricTotalMarks)) {
    //   this.setState({ chkmatric: true, matric: true });
    //   window.scrollTo(0, 1200);
    // }
    // else if (this.checkField(matricPern)) {
    //   this.setState({ chkmatric: true, matric: true });
    //   window.scrollTo(0, 1200);
    // }
    // else if (this.checkField(matricYear)) {
    //   this.setState({ chkmatric: true, matric: true });
    //   window.scrollTo(0, 1200);
    // } else if (this.checkField(matricInstitute)) {
    //   this.setState({ chkmatric: true, matric: true });
    //   window.scrollTo(0, 1200);
    // }
    // else if (this.checkField(interMarks)) {
    //   this.setState({ chkinter: true, inter: true });
    //   window.scrollTo(0, 1300);
    // } else if (this.checkField(interTotalMarks)) {
    //   this.setState({ chkinter: true, inter: true });
    //   window.scrollTo(0, 1300);
    // }
    // else if (this.checkField(interPern)) {
    //   this.setState({ chkinter: true, inter: true });
    //   window.scrollTo(0, 1300);
    // }
    // else if (this.checkField(interYear)) {
    //   this.setState({ chkinter: true, inter: true });
    //   window.scrollTo(0, 1300);
    // } else if (this.checkField(interInstitute)) {
    //   this.setState({ chkinter: true, inter: true });
    //   window.scrollTo(0, 1300);
    // }
    else if (this.checkField(stdIncome)) {
      this.setState({ chkstdIncome: true });
      window.scrollTo(0, 2000);
    } else if (this.checkField(fthIncome)) {
      this.setState({ chkfthIncome: true });
      window.scrollTo(0, 2000);
    } else if (this.checkField(stdOccupation)) {
      this.setState({ chkstdOccupation: true });
      window.scrollTo(0, 2000);
    } else if (this.checkField(fthOccupation)) {
      this.setState({ chkfthOccupation: true });
      window.scrollTo(0, 2000);
    } else if (this.checkField(stdOrganization)) {
      this.setState({ chkstdOrganization: true });
      window.scrollTo(0, 2000);
    } else if (this.checkField(fthOrganization)) {
      this.setState({ chkfthOrganization: true });
      window.scrollTo(0, 2000);
    } else if (this.checkField(stdDepartment)) {
      this.setState({ chkstdDepartment: true });
      window.scrollTo(0, 2000);
    } else if (this.checkField(fthDepartment)) {
      this.setState({ chkfthDepartment: true });
      window.scrollTo(0, 2000);
    } else if (this.checkField(stdDesignation)) {
      this.setState({ chkstdDesignation: true });
      window.scrollTo(0, 2200);
    } else if (this.checkFieldArr(fthDesignation)) {
      this.setState({ chkfthDesignation: true });
      window.scrollTo(0, 2200);
    } else if (this.checkField(stdDependent)) {
      this.setState({ chkstdDependent: true });
      window.scrollTo(0, 2200);
    } else if (this.checkFieldArr(fthDependent)) {
      this.setState({ chkfthDependent: true });
      window.scrollTo(0, 22002000);
    } else if (this.checkField(selectedCourse)) {
      this.setState({ chkSelectedCourse: true });
      window.scrollTo(0, 2400);
    } else if (this.checkFieldArr(selectedCourseList)) {
      this.setState({ chkSelectedCourseList: true });
      window.scrollTo(0, 2400);
    } else {
      let obj = {
        fullName,
        stnNic,
        fatherName,
        FatGuarCNIC,
        resAddress,
        contact,
        whatsapp,
        email,
        city,
        gender,
        date,
        matricMarks,
        matricTotalMarks,
        matricPern,
        matricYear,
        matricInstitute,
        interMarks,
        interTotalMarks,
        interPern,
        interYear,
        interInstitute,
        selectedCourse,
        selectedCourseList,
        GraduationInstitute,
        GraduationYear,
        GraduationMarks,
        GraduationTotalMarks,
        GraduationPern,
        MasterInstitute,
        MasterYear,
        MasterMarks,
        MasterTotalMarks,
        MasterPern,
        aLevelInstitute,
        aLevelYear,
        aPlusOlevel,
        aOlevel,
        bOlevel,
        cOlevel,
        dOlevel,
        eOlevel,
        uOlevel,
        aPlusAlevel,
        aAlevel,
        bAlevel,
        cAlevel,
        dAlevel,
        eAlevel,
        uAlevel,
        olevelInstitute,
        olevelYear,
        stdIncome,
        fthIncome,
        stdOccupation,
        fthOccupation,
        stdOrganization,
        fthOrganization,
        stdDepartment,
        fthDepartment,
        stdDesignation,
        fthDesignation,
        stdDependent,
        fthDependent,
      };
      // console.log(obj, "sad");
      firebase
        .database()
        .ref("/")
        .child(`forms/${selectedCourse}`)
        .push(obj)
        .then((success) => {
          this.setState({
            fullName: "",
            stnNic: "",
            fatherName: "",
            FatGuarCNIC: "",
            resAddress: "",
            contact: "",
            whatsapp: "",
            email: "",
            city: "Karachi",
            gender: "Male",
            date: "",
            matricMarks: 0,
            matricTotalMarks: 0,
            matricPern: 0,
            matricYear: "",
            matricInstitute: "",
            interMarks: "",
            interTotalMarks: "",
            interPern: "",
            interYear: "",
            interInstitute: "",
            selectedCourse: "",
            selectedCourseList: [],
            GraduationInstitute: "",
            GraduationYear: "",
            GraduationMarks: "",
            GraduationTotalMarks: "",
            GraduationPern: "",
            MasterInstitute: "",
            MasterYear: "",
            MasterMarks: "",
            MasterTotalMarks: "",
            MasterPern: "",
            currentData: [],
            aPlusOlevel: "",
            aOlevel: "",
            bOlevel: "",
            cOlevel: "",
            dOlevel: "",
            eOlevel: "",
            uOlevel: "",
            aPlusAlevel: "",
            aAlevel: "",
            bAlevel: "",
            cAlevel: "",
            dAlevel: "",
            eAlevel: "",
            uAlevel: "",
            olevelInstitute: "",
            olevelYear: "",
            aLevelInstitute: "",
            aLevelYear: "",
            stdIncome: "",
            fthIncome: "",
            stdOccupation: "",
            fthOccupation: "",
            stdOrganization: "",
            fthOrganization: "",
            stdDepartment: "",
            fthDepartment: "",
            stdDesignation: "",
            fthDesignation: "",
            stdDependent: "",
            fthDependent: "",
          });
          alert("Your form is successfully submitted");
          window.scrollTo(0, 0);
        })
        .catch((err) => {
          this.setState({
            fullName: "",
            stnNic: "",
            fatherName: "",
            FatGuarCNIC: "",
            resAddress: "",
            contact: "",
            whatsapp: "",
            email: "",
            city: "Karachi",
            gender: "Male",
            date: "",
            matricMarks: 0,
            matricTotalMarks: 0,
            matricPern: 0,
            matricYear: "",
            matricInstitute: "",
            interMarks: "",
            interTotalMarks: "",
            interPern: "",
            interYear: "",
            interInstitute: "",
            selectedCourse: "",
            selectedCourseList: [],
            GraduationInstitute: "",
            GraduationYear: "",
            GraduationMarks: "",
            GraduationTotalMarks: "",
            GraduationPern: "",
            MasterInstitute: "",
            MasterYear: "",
            MasterMarks: "",
            MasterTotalMarks: "",
            MasterPern: "",
            currentData: [],
            aPlusOlevel: "",
            aOlevel: "",
            bOlevel: "",
            cOlevel: "",
            dOlevel: "",
            eOlevel: "",
            uOlevel: "",
            aPlusAlevel: "",
            aAlevel: "",
            bAlevel: "",
            cAlevel: "",
            dAlevel: "",
            eAlevel: "",
            uAlevel: "",
            olevelInstitute: "",
            olevelYear: "",
            aLevelInstitute: "",
            aLevelYear: "",
            stdIncome: "",
            fthIncome: "",
            stdOccupation: "",
            fthOccupation: "",
            stdOrganization: "",
            fthOrganization: "",
            stdDepartment: "",
            fthDepartment: "",
            stdDesignation: "",
            fthDesignation: "",
            stdDependent: "",
            fthDependent: "",
          });
          alert("Your form is not submitted");
          window.scrollTo(0, 0);
        });
    }
  };

  render() {
    const {
      GraduationInstitute,
      GraduationYear,
      GraduationMarks,
      GraduationTotalMarks,
      GraduationPern,
      MasterInstitute,
      MasterYear,
      MasterMarks,
      MasterTotalMarks,
      MasterPern,
      matricYear,
      matricInstitute,
      interMarks,
      interYear,
      interInstitute,
      interPern,
      interTotalMarks,
      chkmatric,
      matricMarks,
      matricTotalMarks,
      matricPern,
      city,
      value,
      date,
      fullName,
      stnNic,
      fatherName,
      FatGuarCNIC,
      resAddress,
      contact,
      whatsapp,
      email,
      aPlusOlevel,
      aOlevel,
      bOlevel,
      cOlevel,
      dOlevel,
      eOlevel,
      uOlevel,
      olevelInstitute,
      olevelYear,
      aAlevel,
      bAlevel,
      cAlevel,
      dAlevel,
      eAlevel,
      uAlevel,
      aLevelInstitute,
      aLevelYear,
      aPlusAlevel,
    } = this.state;
    return (
      <div>
        <Header />
        <h1 className="text-center">Registration</h1>
        <div className="container p-5">
          <div className="formStep p-5">
            <div className="row">
              <div className="col-md-6 py-5">
                <Input
                  placeholder="Full Name"
                  title="Full Name"
                  type="text"
                  value={fullName}
                  onChangeValue={(e) =>
                    this.onChangeValueHandler(e, "fullName", "chkfullName")
                  }
                />
                {this.state.chkfullName ? (
                  <h6 class="text-danger text-left mt-2 ">*Field is empty</h6>
                ) : null}
              </div>
              <div className="col-md-6 py-5">
                <Input
                  placeholder="42***********"
                  title="Student CNIC"
                  type="text"
                  type="number"
                  value={stnNic}
                  onChangeValue={(e) => {
                    this.setState({ chkstnNicLen: false });
                    this.onChangeValueHandler(e, "stnNic", "chkstnNic");
                  }}
                />
                {this.state.chkstnNicLen ? (
                  <h6 class="text-danger text-left mt-2 ">*Invalid CNIC</h6>
                ) : null}
                {this.state.chkstnNic ? (
                  <h6 class="text-danger text-left mt-2 ">*Field is empty</h6>
                ) : null}
              </div>
              <div className="col-md-6 py-5">
                <Input
                  placeholder="Father Name"
                  title="Father Name"
                  value={fatherName}
                  onChangeValue={(e) =>
                    this.onChangeValueHandler(e, "fatherName", "chkfatherName")
                  }
                />
                {this.state.chkfatherName ? (
                  <h6 class="text-danger text-left mt-2 ">*Field is empty</h6>
                ) : null}
              </div>
              <div className="col-md-6 py-5">
                <Input
                  placeholder="42***-*******-*"
                  title="Father / Guardian CNIC"
                  type="number"
                  value={FatGuarCNIC}
                  onChangeValue={(e) => {
                    this.setState({ chkFatGuarCNICLen: false });
                    this.onChangeValueHandler(
                      e,
                      "FatGuarCNIC",
                      "chkFatGuarCNIC"
                    );
                  }}
                />
                {this.state.chkFatGuarCNICLen ? (
                  <h6 class="text-danger text-left mt-2 ">*Invalid CNIC</h6>
                ) : null}
                {this.state.chkFatGuarCNIC ? (
                  <h6 class="text-danger text-left mt-2 ">*Field is empty</h6>
                ) : null}
              </div>
              <div className="col-md-6 py-5">
                <Input
                  placeholder="example@gmail.com"
                  type="email"
                  title="Email"
                  value={email}
                  onChangeValue={(e) =>
                    this.onChangeValueHandler(e, "email", "chkemail")
                  }
                />
                {this.state.chkemail ? (
                  <h6 class="text-danger text-left mt-2 ">*Field is empty</h6>
                ) : null}
              </div>
              <div className="col-md-6 py-5">
                <Input
                  placeholder=" Residential Address"
                  title="Residential Address"
                  type="text"
                  value={resAddress}
                  onChangeValue={(e) =>
                    this.onChangeValueHandler(e, "resAddress", "chkresAddress")
                  }
                />
                {this.state.chkresAddress ? (
                  <h6 class="text-danger text-left mt-2 ">*Field is empty</h6>
                ) : null}
              </div>
              <div className="col-md-6 py-5">
                <Input
                  placeholder="03*********"
                  title="Contact"
                  value={contact}
                  type="number"
                  onChangeValue={(e) => {
                    this.onChangeValueHandler(e, "contact", "chkcontact");
                    this.setState({ chkcontactlen: false });
                  }}
                />
                {this.state.chkcontactlen ? (
                  <h6 class="text-danger text-left mt-2 ">*Invalid number</h6>
                ) : null}
                {this.state.chkcontact ? (
                  <h6 class="text-danger text-left mt-2 ">*Field is empty</h6>
                ) : null}
              </div>
              <div className="col-md-6 py-5">
                <Input
                  placeholder=" 03*********"
                  title="Whatsapp"
                  value={whatsapp}
                  type="number"
                  onChangeValue={(e) => {
                    this.setState({ chkwhatsapplen: false });
                    this.onChangeValueHandler(e, "whatsapp", "chkwhatsapp");
                  }}
                />
                {this.state.chkwhatsapplen ? (
                  <h6 class="text-danger text-left mt-2 ">*Invalid number</h6>
                ) : null}
                {this.state.chkwhatsapp ? (
                  <h6 class="text-danger text-left mt-2 ">*Field is empty</h6>
                ) : null}
              </div>
              <div className="col-md-6 py-5">
                <label className="lab" for="">
                  Select City
                </label>
                <select
                  className="inp"
                  value={this.state.city}
                  onChange={(e) =>
                    this.setState({ city: e.target.value, chkcity: false })
                  }
                >
                  <option value="Karachi">Karachi</option>
                  {this.state.cities.map((item, i) => {
                    return (
                      <option key={i} value={item}>
                        {item}
                      </option>
                    );
                  })}
                </select>
                {this.state.chkcity ? (
                  <h6 class="text-danger text-left mt-2 ">*Select your city</h6>
                ) : null}
              </div>
              <div className="col-md-6 py-5">
                <label className="lab" for="">
                  Gender
                </label>
                <select
                  className="inp"
                  value={this.state.gender}
                  onChange={(e) =>
                    this.setState({ gender: e.target.value, chkgender: false })
                  }
                >
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option>Transgender</option>
                </select>
                {this.state.chkgender ? (
                  <h6 class="text-danger text-left mt-2 ">
                    *Select your gender
                  </h6>
                ) : null}
              </div>
              <div className="col-md-6 py-5">
                <label className="lab">Select Date Of Birth</label>
                <input
                  className="inp"
                  type="date"
                  max="2008-12-31"
                  value={this.state.date}
                  onChange={(e) =>
                    this.setState({ date: e.target.value, chkdate: false })
                  }
                />
                {this.state.chkdate ? (
                  <h6 class="text-danger text-left mt-2 ">*Select your DOB</h6>
                ) : null}
              </div>
            </div>
          </div>
          <div className="formStep">
            <div className="py-5">
              <h2 className="text-center">Select Qualification</h2>
              <strong style={{ color: "#04658a", fontSize: "1.3em" }}>
                Attention: Missing/incorrect information of education and income
                will render your form rejected.
              </strong>
              <ul className="qualification">
                <li>
                  <p
                    onClick={() =>
                      this.setState({ matric: !this.state.matric })
                    }
                  >
                    Matric
                  </p>
                  {this.state.matric ? (
                    <div className="row">
                      <div className="col-md-4">
                        <input
                          className="inp"
                          placeholder="Institute"
                          value={matricInstitute}
                          onChange={(e) =>
                            this.onChangeValueHandler(
                              e,
                              "matricInstitute",
                              "chkmatric"
                            )
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Year"
                          value={matricYear}
                          onChange={(e) => {
                            this.setState({ matricYearlen: false });
                            this.onChangeValueHandler(
                              e,
                              "matricYear",
                              "chkmatric"
                            );
                          }}
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Marks Obtain"
                          value={matricMarks}
                          onChange={(e) =>
                            this.onChangeValueHandler(
                              e,
                              "matricMarks",
                              "chkmatric"
                            )
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Total Marks"
                          value={matricTotalMarks}
                          onChange={(e) =>
                            this.onChangeValueHandler(
                              e,
                              "matricTotalMarks",
                              "chkmatric"
                            )
                          }
                        />
                      </div>
                      {/* <div className="col-md-2">
                        <input
                          className="inp"
                          placeholder="%"
                          value={matricPern}
                          onChange={(e) =>
                            this.onChangeValueHandler(
                              e,
                              "matricPern",
                              "chkmatric"
                            )
                          }
                        />
                      </div> */}
                    </div>
                  ) : null}
                  {this.state.matricYearlen ? (
                    <h6 class="text-danger text-left mt-2 ">*Invalid Year</h6>
                  ) : null}
                  {this.state.chkmatric ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Enter your matriculation info
                    </h6>
                  ) : null}
                </li>
                <li>
                  <p
                    onClick={() =>
                      this.setState({ oLevel: !this.state.oLevel })
                    }
                  >
                    O Level
                  </p>
                  {this.state.oLevel ? (
                    <div className="row">
                      <div className="col-md-4">
                        <input
                          className="inp"
                          placeholder="Institute"
                          value={olevelInstitute}
                          onChange={(e) =>
                            this.onChangeValueHandler(
                              e,
                              "olevelInstitute",
                              "chkolevelInstitute"
                            )
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Year"
                          value={olevelYear}
                          onChange={(e) => {
                            this.setState({ oLevelYearlen: false });
                            this.onChangeValueHandler(
                              e,
                              "olevelYear",
                              "chkolevelYear"
                            );
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                        <table style={{ width: "100%", textAlign: "left" }}>
                          <tr>
                            <th>Grades</th>
                            <th>No of papers</th>
                          </tr>
                          <tr>
                            <th>A*</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={aPlusOlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "aPlusOlevel",
                                    "chkaPlusOlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>A</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={aOlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "aOlevel",
                                    "chkaOlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>B</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={bOlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "bOlevel",
                                    "chkbOlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>C</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={cOlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "cOlevel",
                                    "chkcOlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>D</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={dOlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "dOlevel",
                                    "chkdOlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>E</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={eOlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "eOlevel",
                                    "chkeOlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>U</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={uOlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "uOlevel",
                                    "chkuOlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                        </table>
                      </div>
                    </div>
                  ) : null}
                  {this.state.oLevelYearlen ? (
                    <h6 class="text-danger text-left mt-2 ">*Invalid Year</h6>
                  ) : null}
                  {/* {this.state.chkmatric ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Enter your matriculation info
                    </h6>
                  ) : null} */}
                </li>
                <li>
                  <p
                    onClick={() => this.setState({ inter: !this.state.inter })}
                  >
                    Intermediate
                  </p>
                  {this.state.inter ? (
                    <div className="row">
                      <div className="col-md-4">
                        <input
                          className="inp"
                          placeholder="Institute"
                          value={interInstitute}
                          onChange={(e) =>
                            this.onChangeValueHandler(
                              e,
                              "interInstitute",
                              "chkinter"
                            )
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Year"
                          value={interYear}
                          onChange={(e) => {
                            this.setState({ interYearlen: false });
                            this.onChangeValueHandler(
                              e,
                              "interYear",
                              "chkinter"
                            );
                          }}
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Marks Obtain"
                          value={interMarks}
                          onChange={(e) =>
                            this.onChangeValueHandler(
                              e,
                              "interMarks",
                              "chkinter"
                            )
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Total Marks"
                          value={interTotalMarks}
                          onChange={(e) =>
                            this.onChangeValueHandler(
                              e,
                              "interTotalMarks",
                              "chkinter"
                            )
                          }
                        />
                      </div>
                      {/* <div className="col-md-2">
                        <input
                          className="inp"
                          placeholder="%"
                          value={interPern}
                          onChange={(e) =>
                            this.onChangeValueHandler(
                              e,
                              "interPern",
                              "chkinter"
                            )
                          }
                        />
                      </div> */}
                    </div>
                  ) : null}
                  {this.state.interYearlen ? (
                    <h6 class="text-danger text-left mt-2 ">*Invalid Year</h6>
                  ) : null}
                  {/* {this.state.chkinter ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Enter your matriculation info
                    </h6>
                  ) : null} */}
                </li>
                <li>
                  <p
                    onClick={() =>
                      this.setState({ aLevel: !this.state.aLevel })
                    }
                  >
                    A Level
                  </p>
                  {this.state.aLevel ? (
                    <div className="row">
                      <div className="col-md-4">
                        <input
                          className="inp"
                          placeholder="Institute"
                          value={aLevelInstitute}
                          onChange={(e) =>
                            this.onChangeValueHandler(
                              e,
                              "aLevelInstitute",
                              "chkaLevelInstitute"
                            )
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Year"
                          value={aLevelYear}
                          onChange={(e) => {
                            this.setState({ aLevelYearlen: false });
                            this.onChangeValueHandler(
                              e,
                              "aLevelYear",
                              "chkaLevelYear"
                            );
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                        <table style={{ width: "100%", textAlign: "center" }}>
                          <tr>
                            <th style={{ padding: "0 10px" }}>Grades</th>
                            <th
                              style={{ padding: "0 10px", textAlign: "center" }}
                            >
                              No of papers
                            </th>
                          </tr>
                          <tr>
                            <th>A*</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={aPlusAlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "aPlusAlevel",
                                    "chkaPlusAlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>A</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={aAlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "aAlevel",
                                    "chkaAlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>B</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={bAlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "bAlevel",
                                    "chkbAlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>C</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={cAlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "cAlevel",
                                    "chkcAlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>D</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={dAlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "dAlevel",
                                    "chkdAlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>E</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={eAlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "eAlevel",
                                    "chkeAlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                          <tr>
                            <th>U</th>
                            <th>
                              <input
                                className="inp"
                                type="number"
                                value={uAlevel}
                                onChange={(e) =>
                                  this.onChangeValueHandler(
                                    e,
                                    "uAlevel",
                                    "chkuAlevel"
                                  )
                                }
                              />
                            </th>
                          </tr>
                        </table>
                      </div>
                    </div>
                  ) : null}
                  {this.state.aLevelYearlen ? (
                    <h6 class="text-danger text-left mt-2 ">*Invalid Year</h6>
                  ) : null}
                  {/* {this.state.chkmatric ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Enter your matriculation info
                    </h6>
                  ) : null} */}
                </li>
                <li>
                  <p
                    onClick={() =>
                      this.setState({ graduate: !this.state.graduate })
                    }
                  >
                    Graduation
                  </p>
                  {this.state.graduate ? (
                    <div className="row">
                      <div className="col-md-4">
                        <input
                          className="inp"
                          placeholder="Institute"
                          value={GraduationInstitute}
                          onChange={(e) =>
                            this.onChangeValueHandler(e, "GraduationInstitute")
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Year"
                          value={GraduationYear}
                          onChange={(e) => {
                            this.setState({ GraduationYearlen: false });
                            this.onChangeValueHandler(e, "GraduationYear");
                          }}
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Marks Obtain"
                          value={GraduationMarks}
                          onChange={(e) =>
                            this.onChangeValueHandler(e, "GraduationMarks")
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Total Marks"
                          value={GraduationTotalMarks}
                          onChange={(e) =>
                            this.onChangeValueHandler(e, "GraduationTotalMarks")
                          }
                        />
                      </div>
                      {this.state.GraduationYearlen ? (
                        <h6 class="text-danger text-left mt-2 ">
                          *Invalid Year
                        </h6>
                      ) : null}
                      {/* <div className="col-md-2">
                        <input
                          className="inp"
                          placeholder="%"
                          value={GraduationPern}
                          onChange={(e) =>
                            this.onChangeValueHandler(e, "GraduationPern")
                          }
                        />
                      </div> */}
                    </div>
                  ) : null}
                </li>
                <li>
                  <p
                    onClick={() =>
                      this.setState({ master: !this.state.master })
                    }
                  >
                    Master
                  </p>
                  {this.state.master ? (
                    <div className="row">
                      <div className="col-md-4">
                        <input
                          className="inp"
                          placeholder="Institute"
                          value={MasterInstitute}
                          onChange={(e) =>
                            this.onChangeValueHandler(e, "MasterInstitute")
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Year"
                          value={MasterYear}
                          onChange={(e) => {
                            this.setState({ MasterYearlen: false });
                            this.onChangeValueHandler(e, "MasterYear");
                          }}
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Marks Obtain"
                          value={MasterMarks}
                          onChange={(e) =>
                            this.onChangeValueHandler(e, "MasterMarks")
                          }
                        />
                      </div>
                      <div className="col-md-2">
                        <input
                          className="inp"
                          type="number"
                          placeholder="Total Marks"
                          value={MasterTotalMarks}
                          onChange={(e) =>
                            this.onChangeValueHandler(e, "MasterTotalMarks")
                          }
                        />
                      </div>
                      {/* <div className="col-md-2">
                        <input
                          className="inp"
                          placeholder="%"
                          value={MasterPern}
                          onChange={(e) =>
                            this.onChangeValueHandler(e, "MasterPern")
                          }
                        />
                      </div> */}
                    </div>
                  ) : null}
                  {this.state.MasterYearlen ? (
                    <h6 class="text-danger text-left mt-2 ">*Invalid Year</h6>
                  ) : null}
                </li>
              </ul>
            </div>
          </div>
          <div className="formStep">
            <div className="py-5">
              <h2>Income Details</h2>
              <div className="row">
                <table className="incomeDetail">
                  <thead>
                    <tr>
                      <td></td>
                      <td>Student</td>
                      <td>Father</td>
                    </tr>
                  </thead>
                  <tr>
                    <td>Monthly Income</td>
                    <td>
                      <input
                        type="number"
                        placeholder="Income"
                        className="inp"
                        value={this.state.stdIncome}
                        onChange={(e) => {
                          this.setState({ chkstdIncome: false });
                          this.onChangeValueHandler(
                            e,
                            "stdIncome",
                            "chkstdIncome"
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        placeholder="Income"
                        className="inp"
                        value={this.state.fthIncome}
                        onChange={(e) => {
                          this.setState({ chkfthIncome: false });
                          this.onChangeValueHandler(
                            e,
                            "fthIncome",
                            "chkfthIncome"
                          );
                        }}
                      />
                    </td>
                  </tr>
                  {this.state.chkstdIncome ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Student income field is empty
                    </h6>
                  ) : null}
                  {this.state.chkfthIncome ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Father income field is empty
                    </h6>
                  ) : null}

                  <tr>
                    <td>Occupation</td>
                    <td>
                      <input
                        placeholder="Occupation"
                        className="inp"
                        value={this.state.stdOccupation}
                        onChange={(e) => {
                          this.setState({ chkstdOccupation: false });
                          this.onChangeValueHandler(
                            e,
                            "stdOccupation",
                            "chkstdOccupation"
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        placeholder="Occupation"
                        value={this.state.fthOccupation}
                        className="inp"
                        onChange={(e) => {
                          this.setState({ chkfthOccupation: false });
                          this.onChangeValueHandler(
                            e,
                            "fthOccupation",
                            "chkfthOccupation"
                          );
                        }}
                      />
                    </td>
                  </tr>
                  {this.state.chkstdOccupation ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Student occupation field is empty
                    </h6>
                  ) : null}
                  {this.state.chkfthOccupation ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Father occupation field is empty
                    </h6>
                  ) : null}
                  <tr>
                    <td>Organization</td>
                    <td>
                      <input
                        placeholder="Organization"
                        value={this.state.stdOrganization}
                        className="inp"
                        onChange={(e) => {
                          this.setState({ chkstdOrganization: false });
                          this.onChangeValueHandler(
                            e,
                            "stdOrganization",
                            "chkstdOrganization"
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        placeholder="Organization"
                        value={this.state.fthOrganization}
                        className="inp"
                        onChange={(e) => {
                          this.setState({ chkfthOrganization: false });
                          this.onChangeValueHandler(
                            e,
                            "fthOrganization",
                            "chkfthOrganization"
                          );
                        }}
                      />
                    </td>
                  </tr>
                  {this.state.chkstdOrganization ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Student Organization field is empty
                    </h6>
                  ) : null}
                  {this.state.chkfthOrganization ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Father Organization field is empty
                    </h6>
                  ) : null}
                  <tr>
                    <td>Department</td>
                    <td>
                      <input
                        placeholder="Department"
                        value={this.state.stdDepartment}
                        className="inp"
                        onChange={(e) => {
                          this.setState({ chkstdDepartment: false });
                          this.onChangeValueHandler(
                            e,
                            "stdDepartment",
                            "chkstdDepartment"
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        placeholder="Department"
                        value={this.state.fthDepartment}
                        className="inp"
                        onChange={(e) => {
                          this.setState({ chkfthDepartment: false });
                          this.onChangeValueHandler(
                            e,
                            "fthDepartment",
                            "chkfthDepartment"
                          );
                        }}
                      />
                    </td>
                  </tr>
                  {this.state.chkstdDepartment ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Student Department field is empty
                    </h6>
                  ) : null}
                  {this.state.chkfthDepartment ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Father Department field is empty
                    </h6>
                  ) : null}
                  <tr>
                    <td>Designation</td>
                    <td>
                      <input
                        placeholder="Designation"
                        value={this.state.stdDesignation}
                        className="inp"
                        onChange={(e) => {
                          this.setState({ chkstdDesignation: false });
                          this.onChangeValueHandler(
                            e,
                            "stdDesignation",
                            "chkstdDesignation"
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        placeholder="Designation"
                        value={this.state.fthDesignation}
                        className="inp"
                        onChange={(e) => {
                          this.setState({ chkfthDesignation: false });
                          this.onChangeValueHandler(
                            e,
                            "fthDesignation",
                            "chkfthDesignation"
                          );
                        }}
                      />
                    </td>
                  </tr>
                  {this.state.chkstdDesignation ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Student Designation field is empty
                    </h6>
                  ) : null}
                  {this.state.chkfthDesignation ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Father Designation field is empty
                    </h6>
                  ) : null}
                  <tr>
                    <td>No Of Dependent</td>
                    <td>
                      <input
                        placeholder="Dependent"
                        value={this.state.stdDependent}
                        className="inp"
                        onChange={(e) => {
                          this.setState({ chkstdDependent: false });
                          this.onChangeValueHandler(
                            e,
                            "stdDependent",
                            "chkstdDependent"
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        placeholder="Dependent"
                        value={this.state.fthDependent}
                        className="inp"
                        onChange={(e) => {
                          this.setState({ chkfthDependent: false });
                          this.onChangeValueHandler(
                            e,
                            "fthDependent",
                            "chkfthDependent"
                          );
                        }}
                      />
                    </td>
                  </tr>
                  {this.state.chkstdDependent ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Student Designation field is empty
                    </h6>
                  ) : null}
                  {this.state.chkfthDependent ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Father Designation field is empty
                    </h6>
                  ) : null}
                </table>
              </div>
            </div>
          </div>
          <div className="formStep">
            <div className="p-5">
              <div className="row">
                <div className="col-md-12 text-center">
                  <h3 className="text-center">Select Course</h3>
                  {this.state.courseControl.fiaOpen ? (
                    <button
                      onClick={() =>
                        this.setState({
                          currentData: this.state.fia,
                          selectedCourse: "fia",
                          chkSelectedCourse: false,
                        })
                      }
                      className="customBtn p-3 m-2"
                    >
                      FIA
                    </button>
                  ) : (
                    false
                  )}
                  {this.state.courseControl.accaOpen ? (
                    <button
                      onClick={() =>
                        this.setState({
                          currentData: this.state.acca,
                          selectedCourse: "acca",
                          chkSelectedCourse: false,
                        })
                      }
                      className="customBtn p-3 m-2"
                    >
                      ACCA
                    </button>
                  ) : (
                    false
                  )}
                  {this.state.courseControl.caicapOpen ? (
                    <button
                      onClick={() =>
                        this.setState({
                          currentData: this.state.caicap,
                          selectedCourse: "ca(icap)",
                          chkSelectedCourse: false,
                        })
                      }
                      className="customBtn p-3 m-2"
                    >
                      CA(ICAP)
                    </button>
                  ) : (
                    false
                  )}
                  {this.state.courseControl.icmapOpen ? (
                    <button
                      onClick={() =>
                        this.setState({
                          currentData: this.state.icmap,
                          selectedCourse: "icmap",
                          chkSelectedCourse: false,
                        })
                      }
                      className="customBtn p-3 m-2"
                    >
                      ICMAP
                    </button>
                  ) : (
                    false
                  )}
                  {this.state.courseControl.ciaOpen ? (
                    <button
                      onClick={() =>
                        this.setState({
                          currentData: this.state.cia,
                          selectedCourse: "cia",
                          chkSelectedCourse: false,
                        })
                      }
                      className="customBtn p-3 m-2"
                    >
                      CIA
                    </button>
                  ) : (
                    false
                  )}
                  {this.state.courseControl.cimaOpen ? (
                    <button
                      onClick={() =>
                        this.setState({
                          currentData: this.state.cima,
                          selectedCourse: "cima",
                          chkSelectedCourse: false,
                        })
                      }
                      className="customBtn p-3 m-2"
                    >
                      CIMA
                    </button>
                  ) : (
                    false
                  )}
                  {this.state.courseControl.icaewOpen ? (
                    <button
                      onClick={() =>
                        this.setState({
                          currentData: this.state.icaew,
                          selectedCourse: "icaew",
                          chkSelectedCourse: false,
                        })
                      }
                      className="customBtn p-3 m-2"
                    >
                      ICAEW
                    </button>
                  ) : (
                    false
                  )}
                </div>
                {this.state.chkSelectedCourse ? (
                  <h6 class="text-danger text-left mt-2 ">
                    *Select your course
                  </h6>
                ) : null}
                <div className="col-md-12 text-left p-5">
                  {this.state.currentData.map((item, i) => {
                    return (
                      <label key={i} className="lab">
                        <input
                          type="checkbox"
                          value={item}
                          onChange={(e) => this.handleChange(e, item)}
                        />{" "}
                        {item}
                      </label>
                    );
                  })}
                  {this.state.chkSelectedCourseList ? (
                    <h6 class="text-danger text-left mt-2 ">
                      *Select your course list
                    </h6>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div>
            <button className="customBtn btn-block" onClick={this.submitForm}>
              Submit
            </button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProp(state) {
  return {};
}
function mapDispatchToProp(dispatch) {
  return {
    registerForm: () => {
      dispatch(registerForm());
    },
  };
}
export default connect(mapStateToProp, mapDispatchToProp)(Signup);
